module.exports = __webpack_public_path__ + "img/Proliferation-GBM_10X_TPCP.a73358c4.png";